<template>
  <div :class="spinnerClass">
    <div class="spinner-container">
      <svg class="fade-blink" width="500" height="400" viewBox="0 0 81 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 2C0 0.895431 0.895431 0 2 0V0C3.10457 0 4 0.895431 4 2V21.1233C4 22.2279 3.10457 23.1233 2 23.1233V23.1233C0.895431 23.1233 0 22.2279 0 21.1233V2Z" fill="#7196A0"/>
        <path d="M7.59485 13.5616C7.59485 12.4571 8.49028 11.5616 9.59485 11.5616V11.5616C10.6994 11.5616 11.5948 12.4571 11.5948 13.5616V21.1233C11.5948 22.2279 10.6994 23.1233 9.59485 23.1233V23.1233C8.49028 23.1233 7.59485 22.2279 7.59485 21.1233V13.5616Z" fill="#4E6BE3"/>
        <path d="M15.1896 8.28912C15.1896 7.18456 16.085 6.28912 17.1896 6.28912V6.28912C18.2941 6.28912 19.1896 7.18455 19.1896 8.28912V21.1233C19.1896 22.2279 18.2941 23.1233 17.1896 23.1233V23.1233C16.085 23.1233 15.1896 22.2279 15.1896 21.1233V8.28912Z" fill="#46D8D5"/>
      </svg>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  overlay: {
    type: Boolean,
    default: true
  }
});

const spinnerClass = computed(() => {
  return props.overlay ? 'spinner-overlay' : 'spinner-inline';
});
</script>

<style scoped>
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.spinner-inline {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.spinner-container {
  width: 100px;
  height: 100px;
  text-align: center;
}

.fade-blink {
  animation: fadeBlink 2s infinite;
}

@keyframes fadeBlink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}
</style>